import { FC, ReactNode } from 'react';

import { timeLineHeightBottomPx, timeLineHeightTopPx } from '../../utils/timescale';

const TickSvg: FC<{ mini?: boolean; mwdWidth: number; children: ReactNode; bottom?: boolean }> = ({
  mini = false,
  mwdWidth,
  children,
  bottom = false,
}) => {
  const stickyPosition = bottom
    ? { bottom: '0px', zIndex: 2, height: `${timeLineHeightBottomPx}px` }
    : { top: mini ? '8px' : '0px', zIndex: 2, height: mini ? '50px' : `${timeLineHeightTopPx}px` };

  return (
    <div
      style={{
        width: 'auto',
        backgroundColor: 'var(--tractie-color-background-default)',
        position: mini ? 'inherit' : 'sticky',
        ...stickyPosition,
      }}
    >
      <svg
        viewBox={`0 0 ${mwdWidth} 30`}
        width={mwdWidth}
        height={30}
        overflow='visible'
        style={{
          backgroundColor: 'var(--tractie-color-background-default)',
          position: 'relative',
          ...(bottom ? {} : { bottom: '-22px' }),
        }}
      >
        {children}
      </svg>
    </div>
  );
};
export default TickSvg;
